import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography,
    useTheme
} from "@mui/material";
import {useTranslation} from "react-i18next";
import '../../../style/SalesMarketing.css';
import * as React from "react";
import {useState} from "react";
import IconButton from "@mui/material/IconButton";
import {CloseRounded, DeleteRounded, LibraryAddRounded} from "@mui/icons-material";
import EmptyState from "../../../../../util/component/EmptyState";

interface AddJimpyCodesModalProps {
    open: boolean,
    handleClose: Function,
    watch: Function,
    setValue: Function,
}

const AddJimpyCodesModalModal = ({
                                     open,
                                     handleClose,
                                     watch,
                                     setValue
                                 }: AddJimpyCodesModalProps) => {
    const {t} = useTranslation(['salesmarketing']);
    const theme = useTheme();

    const [codes, setCodes] = useState(watch("jimpyCodes"));

    const insertCodes = () => {
        setValue("jimpyCodes", codes)
    }

    const addCode = () => {
        setCodes([...codes, ""])
    }

    const handleChangeCode = (index: any, value: any) => {
        let list = [...codes];
        list[index] = value;
        setCodes(list);
    }

    const deleteCode = (code:any) => {
        setCodes(codes.filter((c:any) => c !== code));
    }

    return (
        <Dialog disableEscapeKeyDown maxWidth={"sm"} fullWidth={true} open={open}
                onClose={() => {
                    return;
                }}>
            <DialogTitle>
                <Typography sx={{paddingLeft: "10px"}} fontWeight={"bold"} color={"primary"}>
                    {t('salesmarketing:businessAgreement.addJimpyCodes.modalTitle')}
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={() => {
                        handleClose();
                        setCodes(watch("jimpyCodes"));
                    }}
                    color={"primary"}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                    }}
                >
                    <CloseRounded/>
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={2} alignItems={"center"}>
                    <Grid item xs={12}>
                        <Button
                            disabled={codes.some((c:any) => c === "")}
                            sx={{float: "right"}} variant={"text"} color={"accent"}
                            endIcon={<LibraryAddRounded/>} onClick={addCode}>
                            {t('salesmarketing:businessAgreement.addJimpyCodes.add')}
                        </Button>
                        {
                            codes.length === 0 ?
                                <div style={{paddingTop: "45px"}}>
                                    <EmptyState title={t('salesmarketing:businessAgreement.addJimpyCodes.noValuesTitle')}
                                            content={t('salesmarketing:businessAgreement.addJimpyCodes.noValuesContent')}/>
                                </div>
                                :
                                <TableContainer sx={{paddingTop: "10px"}}>
                                    <Table aria-label="ancillaries-table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>{t('salesmarketing:businessAgreement.addJimpyCodes.code')}</TableCell>
                                                <TableCell>{t('salesmarketing:businessAgreement.addJimpyCodes.delete')}</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {codes.map((row: any, index: number) => (
                                                <TableRow
                                                    key={"code" + index}
                                                >
                                                    <TableCell>
                                                        <TextField
                                                            required
                                                            fullWidth
                                                            value={row}
                                                            onChange={(e) => handleChangeCode(index, e.target.value)}

                                                        />
                                                    </TableCell>
                                                    <TableCell>
                                                        <IconButton
                                                            aria-label="delete"
                                                            onClick={() => deleteCode(row)}
                                                            color={"accent"}
                                                        >
                                                            <DeleteRounded/>
                                                        </IconButton>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                        }
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions sx={{backgroundColor: theme.palette.neutral.bright, padding: "15px"}}>
                <Button variant={"outlined"} color={"accent"}
                        onClick={() => {
                            handleClose();
                            setCodes(watch("jimpyCodes"));
                        }}>
                    {t('salesmarketing:businessAgreement.buttons.cancel')}
                </Button>
                <Button disabled={codes.length === 0 || codes.some((c:any) => c === "")} color={"accent"} onClick={() => {
                    insertCodes();
                    handleClose();
                }}>
                    {t('salesmarketing:businessAgreement.addJimpyCodes.insert')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default AddJimpyCodesModalModal;